export const SHARERESULTPOST_REQUEST = "SHARERESULTPOST_REQUEST";
export const SHARERESULTPOST_RECEIVE = "SHARERESULTPOST_RECEIVE";
export const SHARERESULTPOST_FAILURE = "SHARERESULTPOST_FAILURE";
export const RESET_SHARERESULTPOST = "RESET_SHARERESULTPOST";
